import useSWR from "swr";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { Settings } from "./types/settings";

/** The settings' URL, without the calculation: the admin pages invalidate every calculation's on a change. */
export const concreteResinSettingsUrl = "/modules/concrete_resin/settings";

/**
 * What the calculation's page picks its inputs from, in one call: the chemical anchors with their
 * mappings. Every component of the page asking for the same calculation shares the one request.
 */
export const useConcreteResinSettings = (calculationId: string | undefined) => {
  const api = useApi();
  const url = calculationId ? `${concreteResinSettingsUrl}?calculation_id=${encodeURIComponent(calculationId)}` : null;

  return useSWR<Settings, CustomError, string | null>(url, (requestUrl: string) =>
    api.get<Settings>({ url: requestUrl }),
  );
};
